import nodeClient from "./node-client";
const LOGIN_URLS = {
  login: "/service/public/v0/login",
};
export const login = async (payload) => {
  let result = null;
  result = await nodeClient
    .post(LOGIN_URLS.login, payload)
    .catch((reason) => reason.response);
  return result.data;
};
export const isAuthorizedUser = async () => {
  const result = (await sessionStorage.getItem("token"))
    ? Promise.resolve(true)
    : Promise.resolve(false);
  return result;
};
